/* ==============================================================================================
 * ISSUE DETAILS MODAL
 * ============================================================================================== */

var Sushi;
var CGS;

(function (Sushi, Plugins, CGS) {
	"use strict";

	var BasePlugin = Plugins.BasePlugin;
	var OffCanvas = Plugins.OffCanvas;
	var Events = Sushi.Events;

	var DealDetail = function (triggerElement, options) {
		if (Sushi.getPluginInstance("DealDetail", triggerElement)) {
			return;
		}

		this.element = triggerElement;

		BasePlugin.call(this, this.element, options);

		this.element.setAttribute("href", "#");
		this.element.setAttribute("data-off-canvas-content", "#dealDetailModal");
		this.element.setAttribute("data-off-canvas-position", "top right");
		this.element.setAttribute("data-off-canvas-from", "right");
		this.element.setAttribute("data-off-canvas-lock-scroll", "true");
		this.element.setAttribute("data-off-canvas-modifiers", "offCanvas medium");
		this.element.setAttribute("data-off-canvas-opens-from-hash", "false");
		this.element.setAttribute("data-off-canvas-close-on-overlay-click", "true");

		this.modal = new OffCanvas(this.element);

		Events(this.modal.element).on("Modal.open", this.handleModalOpen.bind(this));
		Events(this.modal.element).on("Modal.close", this.handleModalClose.bind(this));
	};

	DealDetail.displayName = "DealDetail";

	DealDetail.prototype = Object.create(BasePlugin.prototype);

	var proto = DealDetail.prototype;

	proto.constructor = DealDetail;

	proto.handleModalClose = function () {
		this.triggerElement.closest("tr").classList.remove("c-table__row--active");
	};

	proto.handleModalOpen = function () {
		this.triggerElement.closest("tr").classList.add("c-table__row--active");

		var issuerNumberElement = this.modal.element.querySelector("[data-issuer-number]");

		var issuerNumber = this.options.issuerNumber;

		issuerNumberElement.innerHTML = issuerNumber;

		// TODO: Update api endpoint URL
		var apiEndpoint = "/json/access/loanDealDetails.json";

		var tableElement = this.modal.element.querySelector("table");

		var columns = [
			{
				"data": "label",
				"className": "c-table__cell",
			},
			{
				"data": "value",
				"className": "c-table__cell",
			},
		];

		CGS.table(tableElement, {
			ajax: {
				url: apiEndpoint,
				dataSrc: function (json) {
					var deals = json["dealFacilityList"];

					var borrowerData = [
						{
							label: "Borrower Number",
							value: json["dealBorrowerNumber"],
						},
						{
							label: "Borrower Name",
							value: json["dealBorrowerName"],
						},
						{
							label: "Deal CUSIP",
							value: json["dealCusip"],
						},
						{
							label: "Domicile",
							value: json["dealDomicile"],
						},
						{
							label: "State",
							value: json["dealState"],
						},
						{
							label: "Deal CUSIP",
							value: json["dealCusip"],
						},
						{
							label: "ISIN",
							value: json["dealIsin"],
						},
						{
							label: "Credit Agreement Date",
							value: json["dealCreditAgreementDate"],
						},
						{
							label: "Global Deal Amount",
							value: json["dealGlobalDealAmount"],
						},
						{
							label: "ISO Currency",
							value: json["dealIsoCurrency"],
						},
						{
							label: "Administrative Agent",
							value: json["dealAdministrativeAgent"],
						},
						{
							label: "Estimated Flag",
							value: json["dealEstimatedFlag"],
						},
					];

					var dealsData = [];

					deals.map(function (deal) {
						dealsData.push({
							type: "empty",
							label: "",
							value: "",
						});

						dealsData.push({
							label: "Facility Data",
							value: "",
							type: "title",
						});

						dealsData.push({
							label: "Facility CUSIP",
							value: deal["facilityCusip"],
						});

						dealsData.push({
							label: "ISIN",
							value: deal["facilityIsin"],
						});

						dealsData.push({
							label: "Maturity",
							value: deal["facilityMaturityDate"],
						});

						dealsData.push({
							label: "Facility Amount",
							value: deal["facilityAmount"],
						});

						dealsData.push({
							label: "ISO Currency",
							value: deal["facilityIsoCurrency"],
						});

						dealsData.push({
							label: "Facility Type",
							value: deal["facilityType"],
						});

						dealsData.push({
							label: "Facility Purpose",
							value: deal["facilityPurpose"],
						});

						dealsData.push({
							label: "Update Date",
							value: deal["facilityUpdateDate"],
						});

						dealsData.push({
							label: "Estimated Flag",
							value: deal["facilityEstimatedFlag"],
						});
					});

					var data = [{
						label: "Deal Data",
						value: "",
						type: "title",
					}]
					.concat(borrowerData)
					.concat(dealsData);

					return data;
				},
			},
			columns: columns,
			columnDefs: [],
			paging: false,
			scrollY: "auto",
			dom: "<'_df _ttu _z10'<'_fxg'><'c-table__export _p0'B>>rt",
			initComplete: function (settings) {
				var scrollHead = settings.nScrollHead;
				var scrollBody = settings.nScrollBody;

				scrollHead.style.display = "none";
				scrollBody.style.overflow = "visible";
				scrollBody.classList.add("_pbxs", "_pb@laptop");
			},
			rowCallback: function (row, data) {
				row.classList.add("c-table__row--compact");

				if (data.type === "title") {
					row.classList.add("c-table__row--title");
				}
				else if (data.type === "empty") {
					row.classList.add("c-table__row--empty");
				}
			},
		});
	};

	Plugins.DealDetail = DealDetail;
})(Sushi || (Sushi = {}), Sushi.Plugins || (Sushi.Plugins = {}), CGS || (CGS = {}));
